import moment from "moment";
import { paymentT } from "../typings/payment";
import { OnlineItemGet } from "../typings/online";

enum LinkPaymentStatusExtra {
    EXPIRED = "expired"
}

export const getPaymentStatus = (payment: paymentT.Payment): paymentT.LinkPaymentStatus | LinkPaymentStatusExtra => {
    const cautionPaid: boolean = payment.nature === paymentT.PaymentNature.DEPOSIT;
    const linkPaymentExpired: boolean = moment(payment.link_payment?.expiration_date).toDate() <= new Date();
    const linkPaymentStatus: paymentT.LinkPaymentStatus = payment.link_payment?.status;
    const linkPaymentPending: boolean = linkPaymentStatus === paymentT.LinkPaymentStatus.PENDING;

    return cautionPaid
        ? paymentT.LinkPaymentStatus.SUCCESS
        : linkPaymentPending && linkPaymentExpired
        ? LinkPaymentStatusExtra.EXPIRED
        : linkPaymentStatus;
};

export const isLink = (payment: paymentT.Payment): boolean => payment.method === paymentT.PaymentMethod.LINK;

export const isDeposit = (payment: paymentT.Payment): boolean => payment?.nature === paymentT.PaymentNature.DEPOSIT;

export const isIntegralPayment = (payment: paymentT.Payment): boolean =>
    payment.nature === paymentT.PaymentNature.INTEGRAL_PAYMENT;

export const isDelivery = (payment: paymentT.Payment): boolean => payment.type === paymentT.PaymentType.DELIVERY;

export const isSlip = (payment: paymentT.Payment): boolean => payment.type === paymentT.PaymentType.ITEM;

export const isDeleted = (payment: paymentT.Payment): boolean =>
    payment.link_payment?.status === paymentT.LinkPaymentStatus.DELETED;

export const isSuccess = (payment: paymentT.Payment): boolean =>
    payment.link_payment?.status === paymentT.LinkPaymentStatus.SUCCESS;

/**
 * Check payments array contains deposit
 * @param {array} payments
 * @returns {boolean}
 */
export const isDepositPaid = (payments: paymentT.Payment[] = []): boolean => payments.some(p => isDeposit(p));

export const isManualPaymentEnabled = (saleEndAt: string): boolean =>
    new Date() > moment(saleEndAt).add(4, "hours").add(30, "minutes").toDate();

export const setPaymentsDeposit = (
    userId: string,
    itemPayments: paymentT.Payment[] = [],
    salePaymentDeposit: paymentT.Payment[] = []
) =>
    (itemPayments || [])
        .concat(salePaymentDeposit.filter(p => p.user_id === userId))
        .filter(
            (p, index, self) =>
                isDeposit(p) &&
                getPaymentStatus(p) === paymentT.LinkPaymentStatus.SUCCESS &&
                index === self.findIndex(s => s.id === p.id)
        );

export const findItemPaymentSlip = (item: OnlineItemGet) => item?.payment?.find(p => isIntegralPayment(p) && isSlip(p));

export const isItemPaymentGrouped = (item: OnlineItemGet, items: OnlineItemGet[]) => {
    const lastBidderId = item.pricing?.last_bid?.user_id;
    const slipPayment = findItemPaymentSlip(item);

    if (slipPayment?.items_ids?.length > 1) {
        return items.filter(i => i.pricing?.last_bid?.user_id === lastBidderId).length > 1;
    }

    if (!slipPayment) {
        return items.filter(i => !findItemPaymentSlip(i) && i.pricing?.last_bid?.user_id === lastBidderId).length > 1;
    }

    return false;
};
